{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "{conversationCount} conversations selected",
    "AGENT_SELECT_LABEL": "Select agent",
    "ASSIGN_CONFIRMATION_LABEL": "Are you sure to assign {conversationCount} {conversationLabel} to",
    "UNASSIGN_CONFIRMATION_LABEL": "Are you sure to unassign {conversationCount} {conversationLabel}?",
    "GO_BACK_LABEL": "Go back",
    "ASSIGN_LABEL": "Assign",
    "YES": "Yes",
    "SEARCH_INPUT_PLACEHOLDER": "Search",
    "ASSIGN_AGENT_TOOLTIP": "Assign agent",
    "ASSIGN_TEAM_TOOLTIP": "Assign team",
    "ASSIGN_SUCCESFUL": "Conversations assigned successfully.",
    "ASSIGN_FAILED": "Failed to assign conversations. Please try again.",
    "RESOLVE_SUCCESFUL": "Conversations resolved successfully.",
    "RESOLVE_FAILED": "Failed to resolve conversations. Please try again.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Conversations visible on this page are only selected.",
    "AGENT_LIST_LOADING": "Loading agents",
    "UPDATE": {
      "CHANGE_STATUS": "Change status",
      "SNOOZE_UNTIL": "Snooze",
      "UPDATE_SUCCESFUL": "Conversation status updated successfully.",
      "UPDATE_FAILED": "Failed to update conversations. Please try again."
    },
    "LABELS": {
      "ASSIGN_LABELS": "Assign labels",
      "NO_LABELS_FOUND": "No labels found for",
      "ASSIGN_SELECTED_LABELS": "Assign selected labels",
      "ASSIGN_SUCCESFUL": "Labels assigned successfully.",
      "ASSIGN_FAILED": "Failed to assign labels. Please try again."
    },
    "TEAMS": {
      "TEAM_SELECT_LABEL": "Select team",
      "NONE": "None",
      "NO_TEAMS_AVAILABLE": "There are no teams added to this account yet.",
      "ASSIGN_SELECTED_TEAMS": "Assign selected team.",
      "ASSIGN_SUCCESFUL": "Teams assigned successfully.",
      "ASSIGN_FAILED": "Failed to assign team. Please try again."
    },
    "MERGE": {
      "TOOLTIP": "Bashko bisedat",
      "TITLE": "Bashko bisedat",
      "DESCRIPTION": "Zgjidhni një bisedë cak. Të gjitha bisedat e tjera të zgjedhura do të bashkohen në të — mesazhet e tyre do të kalohen te biseda cak dhe bisedat burimore do të fshihen.",
      "TARGET_LABEL": "Biseda cak (do të mbahet)",
      "SOURCES_LABEL": "Bisedat burimore (do të fshihen)",
      "SELECT_TARGET": "Zgjidhni një bisedë si cak të bashkimit",
      "WARNING": "Kujdes: ky veprim nuk mund të zhbëhet. Mesazhet nga të gjitha bisedat burimore do të kalohen te biseda cak dhe bisedat burimore do të fshihen përgjithmonë.",
      "SUBMIT": "Bashko bisedat",
      "CANCEL": "Anulo",
      "SUCCESS_MESSAGE": "Bisedat u bashkuan me sukses",
      "ERROR_MESSAGE": "Bisedat nuk mund të bashkoheshin. Provoni përsëri.",
      "CONFIRM": {
        "TITLE": "Konfirmo bashkimin",
        "DESCRIPTION": "Jeni i sigurt që doni të bashkoni {sourceCount} biseda në #{targetId}? Ky veprim nuk mund të zhbëhet.",
        "YES": "Po, bashko",
        "CANCEL": "Anulo"
      }
    }
  }
}
